
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and
// compiles into the necessary css files
require('../scss/index.scss');

import "./app";

require("./utils/accessible-link.js");
require('./components/critical-notice.js');
require('./components/form-submissions.js');
require('./components/iframe-resize.js');

// Inject our components
require('./components/popup-form.js');
require('./components/book-workshop.js');
require('./components/resources-page.js');

// vendor
// require('./vendor/slick-carousel/slick.js');


// 
// require('./components/togglable-content.js');
// require('./components/map.js');
// require('./components/organisation-accordion.js');// 
// require('./components/social-share.js');
// require('./components/testimonials-widget.js');
// require('./components/mobile-menu-trigger.js');
// require('./components/team-member-pagination.js');
// require('./components/resources-page.js');
// require('./components/aog-accordion.js');
// require('./components/trainingcourse-selection.js');
// require('./components/greyscale.js');
// require('./components/sticky-nav.js');
// require('./components/video-popup.js');
// require('./components/client-logo-slider.js');


